import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import "./ChangePassword.css";
import Logo from "../../../Components/Logo/Logo";
import axiosInstance from "../../../Config/axiosConfig";

function ChangePassword({ setLoggedIn, deviceId, userIp }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (values) => {
    if (values.password !== values['confirm-password']) {
      message.error("Passwords do not match");
      return;
    }

    const accessToken = localStorage.getItem("verifyToken");
    const storedDeviceId = deviceId;
    const storedUserIp = userIp;
  
    setLoading(true);
    try {
      const response = await axiosInstance.post("/User/change-password",
        {
          password: values.password,
          confirmPassword: values['confirm-password']
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          },
        }
      );

      if (response.data.code === 200) {
        message.success(response.data.message);
        navigate("/signin");
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || 
        "Failed to change password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-page-container">
      <div className="change-password-container">
        <Logo />
        <h3>Change your password</h3>
        <span className="change-password-text">Enter your password credentials</span>

        <Form className="change-password-form" layout="vertical" onFinish={handleChangePassword}>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please enter your password" },
              { min: 4, message: "Password must be at least 4 characters" },
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="New Password" 
              className="change-password-input" 
            />
          </Form.Item>

          <Form.Item
            name="confirm-password"
            dependencies={['password']}
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('The two passwords do not match');
                },
              }),
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Confirm New Password" 
              className="change-password-input" 
            />
          </Form.Item>

          <Button 
            type="primary" 
            htmlType="submit" 
            className="change-password-button" 
            loading={loading}
          >
            {loading ? "Updating..." : "Update Password"}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ChangePassword;